/*
 *
 * Notifications constants
 *
 */

export const ADD_NOTIFICATION = 'app/Notifications/ADD_NOTIFICATION' as const;
export const REMOVE_NOTIFICATION =
  'app/Notifications/REMOVE_NOTIFICATION' as const;
